export default __webpack_public_path__ + "static/media/gif_cube_pleiq.fb3d666a.gif";